import { createFileRoute } from '@tanstack/react-router'

import EinCorrectionPage from '@/features/ein-correction/pages/ein-correction'

export const Route = createFileRoute('/_shell/ein-correction/')({ component: EinCorrectionPage })
